import { render } from "./nhlDashboardComponent.vue?vue&type=template&id=44b16b46"
import script from "./nhlDashboardComponent.vue?vue&type=script&lang=js"
export * from "./nhlDashboardComponent.vue?vue&type=script&lang=js"

import "./nhlDashboardComponent.vue?vue&type=style&index=0&id=44b16b46&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__